import { IQueryContextDatasourceColumn } from 'src/app/services/query-context/models/IQueryContext';
import { DatasourceColumnDataLoaderFactoryOptions } from './datasource-column';

/** Context filter functionality */
export class DatasourceColumnHelper {
    /** This function is used as a callback in Array.filter to filter out columns based on context.
     * If options.filterContext is true or undefined, it allows all columns to be filtered in except those in options.ignoredContextColumnIds.
     * If options.filterContext is an array, it only aallows columns whose IDs are in the array.
     * If options.filterContext is false, it filters out all columns.
     * @returns - true if the column should be included, false otherwise
     */
    public static filterContextFn(
        col: IQueryContextDatasourceColumn,
        // pick filterContext and ignoredContextColumnIds from DatasourceColumnDataLoaderFactoryOptions
        options: Pick<
            DatasourceColumnDataLoaderFactoryOptions,
            'filterContext' | 'ignoredContextColumnIds'
        >
    ): boolean {
        // If filterContext is undefined or true, then filter out all ignored columns
        if (
            options.filterContext === undefined ||
            options.filterContext === true
        ) {
            // if ignoredContextColumnIds is an array, then filter out all columns in the array
            if (Array.isArray(options.ignoredContextColumnIds)) {
                return !options.ignoredContextColumnIds.includes(col.id);
            }
        }
        // if filterContext is an array, then filter out all columns not in the array
        if (Array.isArray(options.filterContext)) {
            return options.filterContext.includes(col.id);
        }
        return false;
    }
}
